<div fxLayout="column">
<blockquote class="m-0 mb-4 mt-2">
  	<p>Detects configuration conflicts between existing deployed services and the changes being pushed in this deployment.</p>
    <p>Review the conflicted services, inspect differences, and choose whether to keep the current configuration, apply new changes, or merge them.</p>
</blockquote>
<blockquote class="m-0 mb-4" *ngIf="!helperService.loadingSpinner && devices.length == 0; else showDevices">No conflicts or duplicates found</blockquote>

  <ng-template #showDevices>
    <ng-container *ngIf="devices.length > 1; else singleDevice">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div class="bg-app-bar px-6 h-16 border-b left-0 w-full"
        fxLayout="row"
        fxLayoutAlign="space-between center">
          <div fxLayout="row" fxLayoutAlign="start center" class="w-full">
            <h2
              class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l"
              fxFlex="none"
              fxHide.xs
            >
              <span>Devices</span>
            </h2>
            <div
              class="bg-card rounded-full border px-4"
              fxFlex.lt-md="auto"
              fxHide.xs
              fxLayout="row"
              fxLayoutAlign="start center"
              style="width: 40%;"
            >
              <ic-icon [icIcon]="icSearch" size="20px"></ic-icon>
              <input
                class="px-4 py-3 border-0 outline-none w-full bg-transparent"
                placeholder="Search by device name..."
                type="text"
                (input)="searchDevices($event.target.value)"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="overflow-y-auto" fxFlex="auto" [ngStyle]="{ height: deviceHeight}">
        <vex-scrollbar>
          <table class="w-full mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="uppercase mat-header-cell align-left">Device Name</th>
                <th class="uppercase mat-header-cell align-left">Action</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let device of getDevice; let deviceIndex = index">
                <tr class="mat-row">
                  <td class="mat-cell">
                    <span class="primary">{{ device.Name }}</span>
                  </td>
                  <td class="mat-cell">
                    <button
                      mat-raised-button
                      color="warn"
                      type="button"
                      (click)="toggleExpandDevice(deviceIndex)"
                    >
                      Open Conflict
                      <mat-icon class="mat-icon-rtl-mirror">
                        {{
                          expandedDeviceIndex === deviceIndex ? 'expand_more' : 'chevron_right'
                        }}
                      </mat-icon>
                    </button>
                  </td>
                </tr>
                <tr class="mat-row bg-base" *ngIf="expandedDeviceIndex === deviceIndex">
                  <td class="mat-cell" colspan="2">
                    <div
                      class="example-element-detail py-4 w-full"
                      fxLayout="column"
                      class="overflow-auto" [ngStyle]="{ height: expandDeviceHeight }"
                    >
                      <device-card-full-width [device]="device">
                      </device-card-full-width>
                      <div class="mt-4">
                        <vex-pre-deployment-job
                          [jobs]="device.Jobs"
                          [targetInventory]="postingBlueprint[0]"
                        >
                        </vex-pre-deployment-job>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </vex-scrollbar>
      </div>
    </ng-container>
    <ng-template #singleDevice>
      <ng-container *ngIf="devices.length > 0">
        <div
          class="example-element-detail w-full"
          fxLayout="column"
          class="overflow-auto" [ngStyle]="{ height: deviceCardFullHeight }"
        >
          <device-card-full-width [device]="devices[0]">
            <div rightHeaderContent fxLayout="row" fxLayoutAlign="end end">
              <div fxLayout="column">
                <button
                  mat-raised-button
                  color="primary"
                  type="button"
                  (click)="compareDevice(devices[0])"
                >
                  View Diff
                </button>

                <div class="mt-4">
                  <button
                   mat-raised-button
                   color="warn"
                   type="button"
                   class="mr-2"
                   (click)="openConfirmationModal()"
                 >
                   Cancel Deployment
                 </button>
                  <button
                   mat-raised-button
                   class="bg-green text-contrast-white"
                   type="button"
                   (click)="onNextStepper()"
                 >
                   Keep Deployment
                 </button>
                </div>
                <!-- <mat-button-toggle-group class="mt-4">
                  <mat-button-toggle value="Take Source" (click)="openConfirmationModal()">
                    Cancel Deployment
                  </mat-button-toggle>
                  <mat-button-toggle value="Take Target" (click)="onNextStepper()">
                    Proceed with Conflicts
                  </mat-button-toggle>
                  <mat-button-toggle value="Take Merge">
                    <mat-icon [icIcon]="icSync2"></mat-icon>
                    Take Merge
                  </mat-button-toggle> 
                </mat-button-toggle-group> -->
              </div>
            </div>
            <div bottomContent fxLayout="row">
              <div class="card bg-base mb-6 mx-6 w-full">
                <div class="border-b py-4 px-6" fxLayout="row" fxLayoutAlign="start center">
                  <h2 class="m-0 title">Conflicted Services</h2>
                </div>
                <div fxLayout="column" class="w-full p-gutter">
                  <div fxLayout="row">
                    <vex-pre-deployment-job
                      class="w-full"
                      [jobs]="devices[0].Jobs"
                      [targetInventory]="postingBlueprint[0]"
                    >
                    </vex-pre-deployment-job>
                  </div>
                </div>
              </div>
            </div>
          </device-card-full-width>
        </div>
      </ng-container>
    </ng-template>
  </ng-template> 
</div>
